var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDestination(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 18,
    viewBox: "0 0 12 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25938 17.5955C3.62813 15.3326 0 9.84814 0 6.76751C0 3.02987 2.68625 0 6 0C9.3125 0 12 3.02987 12 6.76751C12 9.84814 8.34375 15.3326 6.74062 17.5955C6.35625 18.1348 5.64375 18.1348 5.25938 17.5955ZM6 9.02335C7.10313 9.02335 8 8.01175 8 6.76751C8 5.52328 7.10313 4.51168 6 4.51168C4.89687 4.51168 4 5.52328 4 6.76751C4 8.01175 4.89687 9.02335 6 9.02335Z",
    fill: "#100E34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDestination);
export default __webpack_public_path__ + "static/media/destination.5594617e30a4fddb73c673d76b82b3a9.svg";
export { ForwardRef as ReactComponent };